import { INITIAL_PART_NAME } from "@/const/initialPartStyle";
import { bodyStore } from "@/store/bodyStore";
import { toastStore } from "@/store/toastStore";
import { selectingPartStore } from "@/store/partsStore";
import { useState } from "react";

type DesignResetDialogArg = {
	onApplyClick: () => void;
};

// リセットダイアログのためのロジックを提供します
export default function useDesignResetDialog(arg: DesignResetDialogArg) {
	const { onApplyClick } = arg;
	const { resetBody } = bodyStore();
	const { openToast } = toastStore();
	const { setSelectingPart } = selectingPartStore();

	const [isDialogOpen, setIsDialogOpen] = useState(false);

	// ダイアログの開閉
	const onDialogChange = () => {
		setIsDialogOpen((prev) => !prev);
	};

	// リセットボタンクリック時の処理
	const onResetButtonClick = () => {
		resetBody();
		// 選択しているパーツも解除しないとダメじゃね
		// どちらもundefined？
		// いや、片方はhairかね
		// なお保存時はリセットすることなく、その後も引き続き設定できるように残すのでそのまま
		setSelectingPart({
			partName: INITIAL_PART_NAME,
			partId: undefined,
		});

		onApplyClick();
		onDialogChange();
		openToast({
			type: "success",
			title: "デザインをリセットしました。",
		});
	};

	return { isDialogOpen, onDialogChange, onResetButtonClick };
}
